module.exports = __webpack_public_path__ + "static/img/add.e5e01bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/add.png
// module id = EeGD
// module chunks = 1